import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { AccountAuthControls, useClerkConfigured, useTenantKey } from "../auth";
import { hostApi } from "../lib/api";
import { queryKeys } from "../lib/queryClient";

export function AccountMenu({ placement = "header" }: {
  placement?: "header" | "sidebar";
}) {
  const clerkConfigured = useClerkConfigured();
  const tenantKey = useTenantKey();
  const inSidebar = placement === "sidebar";
  const { data: account } = useQuery({
    queryKey: queryKeys.account(tenantKey),
    queryFn: hostApi.getAccount,
    enabled: !clerkConfigured && tenantKey !== "loading",
  });

  if (clerkConfigured) return <AccountAuthControls showIdentity={inSidebar} />;
  if (!account) return null;
  return (
    <details className={`account-menu${inSidebar ? " account-menu-sidebar" : ""}`}>
      <summary className={inSidebar ? "sidebar-account-trigger" : "account-avatar"} aria-label="Open account menu" title={account.displayName}>
        {inSidebar ? (
          <>
            <span className="account-avatar" aria-hidden="true">{initials(account.displayName, account.email)}</span>
            <span className="sidebar-account-copy"><strong>{account.displayName}</strong><small>{account.email}</small></span>
          </>
        ) : initials(account.displayName, account.email)}
      </summary>
      <div className="account-menu-popover">
        <div className="account-menu-identity">
          <strong>{account.displayName}</strong>
          <span>{account.email}</span>
        </div>
        <Link to="/app/settings">Account settings</Link>
        <a href="/cdn-cgi/access/logout">Sign out</a>
      </div>
    </details>
  );
}

function initials(displayName: string, email: string): string {
  const parts = displayName.trim().split(/\s+/).filter(Boolean);
  if (parts.length > 1) return `${parts[0]![0]}${parts.at(-1)![0]}`.toUpperCase();
  return (parts[0]?.slice(0, 2) || email.slice(0, 2)).toUpperCase();
}
